import { render, staticRenderFns } from "./Pendidikan.vue?vue&type=template&id=4e447608&"
import script from "./Pendidikan.vue?vue&type=script&lang=js&"
export * from "./Pendidikan.vue?vue&type=script&lang=js&"
import style0 from "./Pendidikan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports